
import React from 'react';
import Spinner from 'jsx/elements/spinner';
import LoadingOverlay from 'react-loading-overlay';
import { withRouter } from 'react-router-dom';

const pageLoadingContext = React.createContext(() => {});
export const usePageLoadingContext = () => React.useContext(pageLoadingContext);


const PageLoading = ({children, history }) => {   
    const [isPageLoading, setIsPageLoading] = React.useState(false);   
    
    // history.listen((location, action) => {
    //     // location is an object like window.location
    //     console.log(action, location.pathname, location.state);
    //     setIsPageLoading(true);
    // });

    return (
        <pageLoadingContext.Provider value={setIsPageLoading}>            
            <LoadingOverlay
                styles={{
                    overlay: (base) => ({
                      ...base,
                      background: 'rgba(0, 0, 0, 0.5)'
                    })}}
                active={isPageLoading}                
                spinner={<Spinner center size="large"/>}
            >                
                {children}                
            </LoadingOverlay>
        </pageLoadingContext.Provider>
      );
};

export default withRouter(PageLoading);
